var _circle, _circle2, _circle3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppointmentLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#1552E8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.9989,
    cy: 44.9989,
    r: 42.4286,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1547_127525",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 80,
    height: 80
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.0203,
    cy: 45.0203,
    r: 39.8796,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1547_127525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.668 24.166V30.416",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.332 24.166V30.416",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3333 27.291C60.2708 27.666 63.75 30.3118 63.75 40.1035V52.9785C63.75 61.5618 61.6667 65.8535 51.25 65.8535H38.75C28.3333 65.8535 26.25 61.5618 26.25 52.9785V40.1035C26.25 30.3118 29.7292 27.6868 36.6667 27.291H53.3333Z",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2279 56.666H26.7695",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0013 37.1875C42.4388 37.1875 40.2721 38.5833 40.2721 41.2917C40.2721 42.5833 40.8763 43.5625 41.793 44.1875C40.5221 44.9375 39.793 46.1458 39.793 47.5625C39.793 50.1458 41.7721 51.75 45.0013 51.75C48.2096 51.75 50.2096 50.1458 50.2096 47.5625C50.2096 46.1458 49.4805 44.9167 48.1888 44.1875C49.1263 43.5417 49.7096 42.5833 49.7096 41.2917C49.7096 38.5833 47.5638 37.1875 45.0013 37.1875ZM45.0013 43.1042C43.918 43.1042 43.1263 42.4583 43.1263 41.4375C43.1263 40.3958 43.918 39.7917 45.0013 39.7917C46.0846 39.7917 46.8763 40.3958 46.8763 41.4375C46.8763 42.4583 46.0846 43.1042 45.0013 43.1042ZM45.0013 49.1667C43.6263 49.1667 42.6263 48.4792 42.6263 47.2292C42.6263 45.9792 43.6263 45.3125 45.0013 45.3125C46.3763 45.3125 47.3763 46 47.3763 47.2292C47.3763 48.4792 46.3763 49.1667 45.0013 49.1667Z",
    fill: "#FF8165"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6654 70.0007C66.2677 70.0007 69.9987 66.2697 69.9987 61.6673C69.9987 57.0649 66.2677 53.334 61.6654 53.334C57.063 53.334 53.332 57.0649 53.332 61.6673C53.332 66.2697 57.063 70.0007 61.6654 70.0007Z",
    fill: "white",
    stroke: "#A020FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7709 61.7715H58.5625",
    stroke: "#A020FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.668 58.7305V64.9596",
    stroke: "#A020FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentLogo);
export default __webpack_public_path__ + "static/media/AppointmentLogo.2dc1ea217794f64a402e2ff191231e0c.svg";
export { ForwardRef as ReactComponent };